document.addEventListener('DOMContentLoaded', function () {
  const wrap = document.querySelector('.advent-hero');
  const additionalImages = wrap.querySelectorAll('.additional-image');
  const buyBtns = wrap.querySelectorAll('.product-form__button');

  buyBtns.forEach(button => {
    if (button.dataset.listenerAttached) return;
    button.dataset.listenerAttached = 'true';

    button.addEventListener('click', e => {
      if (!e.isTrusted) return;

      const from = button.classList.contains('sticky_button_form')
        ? 'product_quick_add'
        : 'product_main';

      const prodPriceElement = wrap.querySelector(
        '.no-js-hidden .price-item--sale'
      );
      const priceTarget =
        prodPriceElement && prodPriceElement.querySelector('.money')
          ? prodPriceElement.querySelector('.money')
          : prodPriceElement;

      const formInput = wrap.querySelector('.product-form input[name="id"]');

      addToCartEvent(
        1,
        from,
        formInput.value,
        priceTarget ? priceTarget.textContent.trim() : '',
        formInput.dataset.handle,
        formInput.dataset.url,
        '',
        readPdpEventExtras()
      );
    });
  });

  let swiper = new Swiper('.advent-hero .swiper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: true,
    pagination: {
      el: '.advent-hero .swiper-pagination',
      clickable: true
    }
  });

  document.addEventListener('click', e => {
    if (!e.target.matches('.item input')) return;
    if (!e.target.closest('.advent-hero')) return;

    if (typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(0, 400);
    } else {
      swiper.slideTo(0, 400);
    }
  });

  additionalImages.forEach(function (img) {
    img.classList.remove('tw-opacity-0');
  });

  $('.advent-hero')
    .find('.product_gallery')
    .fancybox({
      loop: true,
      closeExisting: true,
      thumbs: {
        autoStart: false
      }
    });
  if (window.initStampedReviews) {
    window.initStampedReviews({ scopeSelector: '.advent-hero' });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const prodImage = document.querySelector('.preview-image picture');
  const mediaPreviewItems = document.querySelectorAll('.preview-media img');

  mediaPreviewItems.forEach(item => {
    item.addEventListener('click', function () {
      prodImage
        .querySelector('source[media="(min-width: 1440px)"]')
        .setAttribute(
          'srcset',
          `${this.src.replace(/_\d+x\./, '_824x.')}, ${this.src.replace(/_\d+x\./, '_1648x.')} 2x`
        );
      prodImage
        .querySelector('source[media="(min-width: 1024px)"]')
        .setAttribute(
          'srcset',
          `${this.src.replace(/_\d+x\./, '_528x.')}, ${this.src.replace(/_\d+x\./, '_1056x.')} 2x`
        );

      document
        .querySelectorAll('.preview-media div')
        .forEach(div => div.classList.remove('active'));
      this.parentElement.classList.add('active');
    });
  });

  const mainImage = document.querySelector(
    '.horizontal-media .product-image__img'
  );
  if (mainImage) {
    mainImage.addEventListener('click', function () {
      const activeGallery = document.querySelector(
        '.preview-media .active .product_gallery'
      );
      if (activeGallery) activeGallery.click();
    });
  }
});
